var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartWidget',{attrs:{"title":_vm.$t('message.dashboard.widgetTitle.queries'),"tooltip":_vm.$t('message.dashboard.widgetTooltip.queries'),"dataset":_vm.dataset,"loading":_vm.loading,"action-handler":_vm.actionHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }